import { render, staticRenderFns } from "./TileAttribute.vue?vue&type=template&id=7f622965&scoped=true"
import script from "./TileAttribute.vue?vue&type=script&lang=js"
export * from "./TileAttribute.vue?vue&type=script&lang=js"
import style0 from "./TileAttribute.vue?vue&type=style&index=0&id=7f622965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f622965",
  null
  
)

export default component.exports